var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "stone",
    patternUnits: "userSpaceOnUse",
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 10,
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 30,
    r: 15,
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 70,
    r: 20,
    fill: "#696969"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#stone)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStone);
export default __webpack_public_path__ + "static/media/stone.4c28c5240a66bf517a3c1e66b84d6d0b.svg";
export { ForwardRef as ReactComponent };